import { GrowthBook } from '@growthbook/growthbook';

export default defineNuxtPlugin(async (nuxtApp) => {
  const { hostUrl, growthbookApiHost, growthbookSdkKey } =
    useRuntimeConfig().public;

  const options = {
    // Only used for identification (DevTools / debugging). Features are
    // loaded from our cached server route via initSync, so init() is never
    // called and the SDK does not fetch from the CDN itself.
    apiHost: growthbookApiHost,
    clientKey: growthbookSdkKey,
    enableDevMode: process.env.NODE_ENV !== 'production',
    // eslint-disable-next-line no-unused-vars
    trackingCallback: (experiment, result, userContext) => {
      const event = {
        name: 'Experiment Started',
        data: {
          'Experiment Id': experiment.key,
          'Variant Id': result.variationId,
          $source: 'growthbook',
        },
      };

      if (!import.meta.env.SSR) {
        nuxtApp.$analytics.track(event.name, event.data, {
          plugins: {
            all: false,
            mixpanel: true,
            googleAnalytics: true,
          },
        });
      }
    },
  };

  // Create the SDK before any await so it registers with DevTools early.
  const growthbook = new GrowthBook(options);

  const { data } = await useFetch('/api/growthbook/features', {
    key: 'growthbook-features',
    retry: 0,
  });

  growthbook.initSync({
    payload: {
      features: data.value?.features || {},
      experiments: data.value?.experiments || [],
    },
  });

  const route = useRoute();

  const uniqueIdCookie = useCookie('exp_uniqueId');
  let uniqueId = uniqueIdCookie.value;
  if (!uniqueId) {
    uniqueId = crypto.randomUUID();
    uniqueIdCookie.value = uniqueId;
  }

  const dataDogCookie = useCookie('datadog-synthetics-public-id');

  await growthbook.setAttributes({
    id: uniqueId,
    url: `${hostUrl}${route.fullPath}`,
    slug: route.fullPath,
    proxifier: !!route.query?.proxifier,
    datadog_test_id: dataDogCookie.value,
  });

  nuxtApp.provide('growthbook', growthbook);
});
